<template>
  <div class="otherFee">
    <!-- 货品列表 -->
    <div class="goods_box">
      <div class="goods_tool goods_header">
        <div class="goods_header_left">
          <div v-if="active_box == 1">
            <el-radio-group v-model="listQuery.type" @change="handleChangeType" fill="#31b158">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="1">按量收费</el-radio-button>
              <el-radio-button label="2">按单收费</el-radio-button>
            </el-radio-group>
          </div>
          <div v-if="active_box == 2">
            <el-radio-group v-model="listQuery.type" @change="handleChangeType" fill="#31b158">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="1">产地费用</el-radio-button>
              <el-radio-button label="2">市场费用</el-radio-button>
              <!-- <el-radio-button label="3">商品费用</el-radio-button> -->
            </el-radio-group>
          </div>
          <!-- 搜索条 -->
          <div class="list_search">
            <input type="text" v-model="listQuery.name" @input="handleBatchSearch()" placeholder="搜索费用名称" />
            <span class="icon_search">
              <md-icon name="search" size="sm" color="#888"></md-icon>
            </span>
            <span
              class="icon_close"
              v-if="listQuery.name"
              @click="listQuery.name = '';handleBatchSearch()"
            >
              <md-icon name="close" size="sm" color="#888"></md-icon>
            </span>
          </div>
        </div>
        <div class="goods_header_right">
          <button @click="handleAddFee">新增</button>
          <button @click="handleDataFee">统计</button>
        </div>
      </div>
      <div class="goods_section">
        <md-scroll-view
          ref="feeScrollView"
          :scrolling-x="false"
          @refreshing="handleGoodsListRefresh"
          @end-reached="handleGoodsMore"
        >
          <md-scroll-view-refresh
            roller-color="#31B158"
            slot="refresh"
            slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
            :scroll-top="scrollTop"
            :is-refreshing="isRefreshing"
            :is-refresh-active="isRefreshActive"
          ></md-scroll-view-refresh>
          <div class="goods_list">
            <div class="goods_list_item" v-for="(item,index) in list" :key="index" @click="handleUpdateFee(item)">
              <div class>
                <div class="list_item_line_1">{{item.name}}</div>
                <div class="list_item_line_2" v-if="active_box == 1">
                  <div>
                    <span>{{item.price}}{{item.type == 1?'元/个':'元'}} {{item.type == 1?" x "+(item.num-0)+'个':''}}</span>
                  </div>
                  <div class="detete info">
                    <button @click.stop="handleDeleteSaleFee(item)">删除</button>
                  </div>
                </div>
                <div class="list_item_line_2" v-if="active_box == 2">
                  <div>
                    <span v-if="item.type == 1">产地费用</span>
                    <span v-if="item.type == 2">市场费用</span>
                    <span v-if="item.type == 3">商品费用</span>
                  </div>
                  <div class="detete info">
                    <button @click.stop="handleDeleteCostFee(item)">删除</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <md-scroll-view-more :finished-text="list.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="isFinished"></md-scroll-view-more>
        </md-scroll-view>
      </div>
    </div>
    <!-- 添加销售附加费 -->
    <addSaleFee ref="addSaleFee" @finish="handleFinish"></addSaleFee>
    <!-- 添加成本费 -->
    <addCostFee ref="addCostFee" @finish="handleFinish"></addCostFee>
  </div>
</template>

<script>
import { costFee_getList ,costFee_delete,saleFee_getList,saleFee_delete } from "@/api/work/stock";
import addSaleFee from "./addSaleFee";
import addCostFee from "./addCostFee";
export default {
  name: "otherFee",
  components: { addSaleFee,addCostFee},
  data() {
    return {
      active_box:'', // 1 销售附加费 2 成本费用
      listQuery:{
        name:'',
        page:1,
        pageSize:15,
        type:''
      },
      isFinished:false,
      list:[],
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 显示商品
    showBox(type) {
      this.list = []
      this.active_box = type 
      this.listQuery.page = 1
      this.listQuery.name = ''
      this.listQuery.pageSize = 15
      this.listQuery.type = ''
      this.$refs.feeScrollView.scrollTo(0,0);
      this.getFee()
    },

    // 获取成本费用列表
    getFee() {
      if(this.active_box == 1){
        saleFee_getList(this.listQuery).then(res => {
          if (res.code == 200) {
            if (this.listQuery.page == 1) this.list = [];
            this.list = this.list.concat(res.data.list);
            if ( this.list.length >= res.data.totalCount || res.data.list.length == 0 ) {
              this.isFinished = true;
            } else {
              this.isFinished = false;
              this.listQuery.page++;
            }
            this.$nextTick(()=>{
              this.$refs.feeScrollView.finishRefresh()
            })
          }
        });
      }else{
        costFee_getList(this.listQuery).then(res => {
          if (res.code == 200) {
            if (this.listQuery.page == 1) this.list = [];
            this.list = this.list.concat(res.data.list);
            if ( this.list.length >= res.data.totalCount || res.data.list.length == 0 ) {
              this.isFinished = true;
            } else {
              this.isFinished = false;
              this.listQuery.page++;
            }
            this.$nextTick(()=>{
              this.$refs.feeScrollView.finishRefresh()
            })
          }
        });
      }
    },
    // 搜索输入后立马查询
    handleBatchSearch() {
      this.listQuery.page = 1;
      this.getFee()
    },

    // 筛选切换
    handleChangeType(){
      this.listQuery.page = 1
      this.getFee()
    },

    // 下拉刷新数据
    handleGoodsListRefresh() {
      this.listQuery.page = 1;
      setTimeout(()=>{
        this.getFee()
      },500)
    },
    // 上拉加载更多数据
    handleGoodsMore() {
      setTimeout(() => {
        this.isFinished = true;
      }, 2000);
    },
    // 其他地方操作数据后的回调
    handleFinish(){
      this.listQuery.page = 1;
      this.getFee()
    },
    // 点击了新增
    handleAddFee() {
      if(this.active_box == 1){
        this.$refs.addSaleFee.showPop();
      }else{
        this.$refs.addCostFee.showPop();
      }
    },

    // 编辑
    handleUpdateFee(item){
      if(this.active_box == 1){
        this.$refs.addSaleFee.showPop(item);
      }else{
        this.$refs.addCostFee.showPop(item);
      }
    },

    // 商品内部按钮
    // 删除
    handleDeleteSaleFee(item) {
      this.$dialog.confirm({
        title: "确认",
        content: "是否删除该附加费？",
        confirmText: "确定",
        onConfirm: () => {
          saleFee_delete({id:item.id}).then(res=>{
            if(res.code == 200 ){
              this.$toast.succeed(res.message)
              this.handleFinish()
            }
          })
        }
      });
    },
    handleDeleteCostFee(item) {
      this.$dialog.confirm({
        title: "确认",
        content: "是否删除该费用？",
        confirmText: "确定",
        onConfirm: () => {
          costFee_delete({id:item.id}).then(res=>{
            if(res.code == 200 ){
              this.$toast.succeed(res.message)
              this.handleFinish()
            }
          })
        }
      });
    },

    // 点击了统计 type == 1?附加费：成本费
    handleDataFee(type){
      this.$router.push({
        path:'/stock/dataFee',
        query:{
          type:this.active_box
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.otherFee {
  position: relative;
  display: flex;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  .goods_box {
    width: 100%;
    height: 100%;
    .goods_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 0.64rem;
      padding: 0 0.16rem;
      background-color: #fff;
      .goods_header_left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .title {
          font-size: 0.26rem;
          font-weight: bold;
          line-height: 0.64rem;
        }
        .number {
          font-size: 0.2rem;
          margin-left: 0.2rem;
          margin-right: 0.3rem;
          color: #999;
          line-height: 0.64rem;
        }
        .list_search {
          width: 3rem !important;
          height: 0.48rem;
          background-color: #fff;
          box-sizing: border-box;
          padding: 0.05rem 0;
          margin-left: 0.2rem;
          position: relative;
          input {
            line-height: 0.4rem;
            font-size: 0.2rem;
            border: none;
            outline: none;
            background-color: #e6e6e6;
            width: 100%;
            text-indent: 0.4rem;
          }
          span.icon_search {
            position: absolute;
            left: 0.12rem;
            top: 0.12rem;
          }
          span.icon_close {
            position: absolute;
            left: 0.12rem;
            top: 0.12rem;
          }
        }
      }
      .goods_header_right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        button {
          height: 0.36rem !important;
          line-height: 0.36rem !important;
          font-size: 0.2rem;
          padding: 0 0.15rem;
          border-radius: 0.04rem;
          color: #31b158;
          margin-left: .2rem;
          border: 0.01rem solid #31b158;
          font-size: 0.18rem;
          box-sizing: content-box;
          background-color: #fff;
          &:active {
            color: #fff;
            background-color: #31b158;
          }
          &.active{
            color: #fff;
            background-color: #31b158;
          }
        }
      }
    }
    .goods_tool {
      position: relative;
      z-index: 2;
      margin-bottom: 0;
      box-shadow: 0 0.02rem 0.06rem 0.01rem #e1e1e1;
      border-bottom: none;
      button {
        height: 0.32rem !important;
        line-height: 0.32rem !important;
        font-size: 0.18rem;
      }
      .list_search{
        width: 2rem !important;
        height: 0.4rem !important;
        padding: 0 !important;
        margin-right: 0.15rem;
        span{
          top: 0.07rem !important;
        }
        .icon_search{
          left: 0.1rem !important;
        }
      }
    }
    .goods_section {
      height: calc(100% - 0.64rem);
      padding: 0 0.08rem;
      overflow: auto;
      background-color: #fff;
      .goods_list {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 0.2rem;
        .goods_list_item {
          width: 50%;
          padding: 0 0.08rem;
          margin-bottom: 0.15rem;
          position: relative;
          & > div {
            width: 100%;
            height: 100%;
            border-radius: 0.08rem;
            // border: 0.02rem solid #31b158;
            box-shadow: 0 0 0.08rem 0.02rem #e5e5e5; 
            padding: 0.1rem;
            .list_item_line_1 {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              font-size: 0.28rem;
              font-weight: bold;
              max-width: 4rem;
            }
            .list_item_line_2 {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 0.1rem;
              color: #666;
              font-size: 0.2rem;
              .info button{
                color: #fa4a5e;
                border: 0.01rem solid #fa4a5e;
                height: 0.4rem;
                line-height: 0.4rem;
                padding: 0 0.12rem;
                background-color: #fff;
                border-radius: 0.04rem;
                font-size: 0.2rem;
                box-sizing: content-box;
                &:active{
                  color: #fff;
                  background-color: #fa4a5e;
                }
              }
            }
          }
        }
      }
    }
    .goods_no {
      line-height: 0.8rem;
      text-align: center;
      color: #999;
    }
  }
}
</style>
<style lang="less">
.otherFee{
  .el-radio-group{
    .el-radio-button {
      .el-radio-button__inner{
        font-size: 0.2rem;
        padding:0 0.12rem;
        line-height: 0.38rem;
      }
    }
  }
}
</style>